/**
 * Actions Types
 */

export enum DadosBancariosTypes {
  BANCOS_REQUEST = '@refinanciamento/dadosBancarios/BANCOS_REQUEST',
  BANCOS_SUCCESS = '@refinanciamento/dadosBancarios/BANCOS_SUCCESS',
  SET_BANCOS_ERROR = '@refinanciamento/dadosBancarios/SET_BANCOS_ERROR',
  SET_BANCO_SELECIONADO = '@refinanciamento/dadosBancarios/SET_BANCO_SELECIONADO',
  SET_BANCO_NOME = '@refinanciamento/dadosBancarios/SET_BANCO_NOME',
  SET_TIPO_CONTA = '@refinanciamento/dadosBancarios/SET_TIPO_CONTA',
  SET_TIPO_CREDITO_INSS = '@refinanciamento/dadosBancarios/SET_TIPO_CREDITO_INSS',
  SET_AGENCIA = '@refinanciamento/dadosBancarios/SET_AGENCIA',
  SET_CONTA_DADOS_BANCARIOS = '@refinanciamento/dadosBancarios/SET_CONTA_DADOS_BANCARIOS',
  SET_DIGITO = '@refinanciamento/dadosBancarios/SET_DIGITO',
  CLEAR_ACCOUNT_FIELDS = '@refinanciamento/dadosBancarios/CLEAR_ACCOUNT_FIELDS',
  SET_BANCOS_LOADING = '@refinanciamento/dadosBancarios/SET_BANCOS_LOADING',
  SET_IS_BANK_ACCOUNT_EDITABLE = '@refinanciamento/dadosBancarios/SET_IS_BANK_ACCOUNT_EDITABLE',
  GET_CAPTURE_ACCOUNT_ENABLED = '@portabilidade/dadosBancarios/GET_CAPTURE_ACCOUNT_ENABLED',
  RESET = 'RESET',
}

/**
 * Data Types
 */

export interface Banco {
  nome: string
  codigo: string
  ispb: string
}

/**
 * State Type
 */

export interface DadosBancariosState {
  readonly bancos?: Banco[]
  readonly bancoSelecionado?: string
  readonly bancoNome?: string
  readonly tipoContaSelecionado?: number
  readonly tipoCreditoInss?: number
  readonly agencia: string
  readonly contaDadosBancarios: string
  readonly digito: string
  readonly isBankAccountEditable?: boolean
  readonly loading?: boolean
}

export interface BancosAPI {
  bancos: Banco[]
}

export type SalvarPropostaPayload = {
  callback: () => void
}

export interface ValidaPropostaPayload {
  callback?: (contato: boolean) => void
}

export interface GetBancosPayload {
  callback?: (bancos: Banco[] | null) => void
  saveToState?: boolean
}

export type GetBancosSagaPayload = {
  type: string
  payload: GetBancosPayload
}
